import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  requestOptions: any;

  constructor(private http: HttpClient) {}

  sendNotificationData(payload: any): Observable<any> {
    const headerDict = {
      Authorization: `key=${environment.serverKey}`,
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    return this.http.post('https://fcm.googleapis.com/fcm/send', payload, requestOptions);
  }
}
